module.exports = __webpack_public_path__ + "images/arrow35b436625832c1af1c96deac5d36ed4a.svg";